export const utmMarks = [
    'utm_manager',
    'utm_source',
    'utm_comment',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content'
];
